import { z } from 'zod';
import { AnswerAreaPinComponentSchema } from './answer-area-pin-component';
import { AudioPinComponentSchema } from './audio-pin-component';
import { CategoryAreaPinComponentSchema } from './category-area-pin-component';
import { DropZonePinComponentSchema } from './drop-zone-pin-component';
import { FillInTheBlanksAreaPinComponentSchema } from './fill-in-the-blanks-area-pin-component';
import { HotspotPinComponentSchema } from './hotspot-pin-component';
import { ImagePinComponentSchema } from './image-pin-component';
import { LinePinComponentSchema } from './line-pin-component';
import { ShapePinComponentSchema } from './shape-pin-component';
import { SpinnerPinComponentSchema } from './spinner-pin-component';
import { TextPinComponentSchema } from './text-pin-component';
import { TimerPinComponentSchema } from './timer-pin-component';
import { UneditableShapePinComponentSchema } from './uneditable-shape-pin-component';
import { UnsupportedPinComponentSchema } from './unsupported-pin-component';
import { VideoPinComponentSchema } from './video-pin-component';

export type AudioPinComponent = z.infer<typeof AudioPinComponentSchema>;
export type HotspotPinComponent = z.infer<typeof HotspotPinComponentSchema>;
export type ImagePinComponent = z.infer<typeof ImagePinComponentSchema>;
export type LinePinComponent = z.infer<typeof LinePinComponentSchema>;
export type ShapePinComponent = z.infer<typeof ShapePinComponentSchema>;
export type TextPinComponent = z.infer<typeof TextPinComponentSchema>;
export type AnswerAreaPinComponent = z.infer<typeof AnswerAreaPinComponentSchema>;
export type FillInTheBlanksAreaPinComponent = z.infer<typeof FillInTheBlanksAreaPinComponentSchema>;
export type CategoryAreaPinComponent = z.infer<typeof CategoryAreaPinComponentSchema>;
export type UneditableShapePinComponent = z.infer<typeof UneditableShapePinComponentSchema>;
export type VideoPinComponent = z.infer<typeof VideoPinComponentSchema>;
export type SpinnerPinComponent = z.infer<typeof SpinnerPinComponentSchema>;
export type TimerPinComponent = z.infer<typeof TimerPinComponentSchema>;
export type DropZonePinComponent = z.infer<typeof DropZonePinComponentSchema>;
export type UnsupportedPinComponent = z.infer<typeof UnsupportedPinComponentSchema>;

export const PinComponentSchema = z.discriminatedUnion('type', [
  HotspotPinComponentSchema,
  AudioPinComponentSchema,
  ImagePinComponentSchema,
  LinePinComponentSchema,
  ShapePinComponentSchema,
  TextPinComponentSchema,
  AnswerAreaPinComponentSchema,
  CategoryAreaPinComponentSchema,
  FillInTheBlanksAreaPinComponentSchema,
  UneditableShapePinComponentSchema,
  VideoPinComponentSchema,
  SpinnerPinComponentSchema,
  TimerPinComponentSchema,
  DropZonePinComponentSchema,
  UnsupportedPinComponentSchema,
]);
export type PinComponent = z.infer<typeof PinComponentSchema>;

export type PinComponentType = PinComponent['type'];
export type PinComponentOfType<T extends PinComponentType> = Extract<PinComponent, { type: T }>;
